<template>
  <section
    class="ls-story"
    :class="{ 'ls-story--facts-only': !intro }"
    aria-label="About the collection"
  >
    <p
      v-if="intro"
      class="ls-story__intro"
    >{{ intro }}</p>
    <dl
      v-if="facts.length"
      class="ls-story__facts"
    >
      <div
        v-for="fact in facts"
        :key="fact.label"
        class="ls-story__fact"
      >
        <dt>{{ fact.label }}</dt>
        <dd>{{ fact.value }}</dd>
      </div>
    </dl>
  </section>
</template>

<script>
export default {
  name: 'LsStory',
  props: {
    intro: { type: String, default: '' },
    facts: { type: Array, default: () => [] },
  },
}
</script>

<style lang="scss" scoped>
@import './ls-base';

.ls-story {
  display: grid;
  gap: 40px;
  max-width: $ls-max;
  margin: 0 auto;
  padding: clamp(48px, 9vw, 112px) $ls-gutter clamp(40px, 7vw, 88px);

  @include ls-up($ls-lg) {
    grid-template-columns: minmax(0, 7fr) minmax(0, 4fr);
    gap: clamp(48px, 8vw, 128px);
    align-items: start;
  }

  &__intro {
    margin: 0;
    max-width: 60ch;
    color: var(--ls-ink);
    font-family: var(--ls-body-font);
    font-size: clamp(1.125rem, 1.4vw, 1.3125rem);
    line-height: 1.65;
    text-wrap: pretty;
  }

  &__facts {
    margin: 0;
    border-top: 1px solid var(--ls-line);
  }

  &__fact {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    padding: 14px 0;
    border-bottom: 1px solid var(--ls-line);

    dt {
      @include ls-label;
      color: var(--ls-muted);
      padding-top: 3px;
    }

    dd {
      margin: 0;
      color: var(--ls-ink);
      font: 400 1rem/1.4 var(--ls-body-font);
      text-align: right;
    }
  }

  &--facts-only {
    @include ls-up($ls-lg) {
      grid-template-columns: 1fr;
    }

    .ls-story__facts {
      @include ls-up($ls-md) {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        column-gap: 32px;
      }
    }
  }
}
</style>
